import { render } from "./LoginSecurity.vue?vue&type=template&id=53eb0cce&scoped=true"
import script from "./LoginSecurity.vue?vue&type=script&lang=js"
export * from "./LoginSecurity.vue?vue&type=script&lang=js"

import "./LoginSecurity.vue?vue&type=style&index=0&id=53eb0cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eb0cce"]])

export default __exports__